<div class="flex flex-col flex-auto min-w-0">
    <div class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between px-6 py-4 sm:py-2 sm:px-10 bg-card dark:bg-transparent">
        <div class=" flex flex-wrap items-center ">
            <div>
                <a class="whitespace-nowrap text-primary-500" aria-label="igov" [routerLink]="['/']">igov.un.org</a>
            </div>
            <!-- <div *ngFor="let breadcrumb of breadcrumbs; last as isLast" >
                <div *ngIf="breadcrumb.label!=''" class="flex items-center ml-1 whitespace-nowrap">
                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                    <a *ngIf="!isLast" class="ml-1 whitespace-nowrap text-primary-500" [routerLink]="breadcrumb.url">{{getDynamicValue(breadcrumb)}}</a>
                    <span *ngIf="isLast" class="ml-1 text-secondary">{{getDynamicValue(breadcrumb)}}</span>
                    
                </div>
                
            </div> -->

            <div *ngFor="let breadcrumb of _breadcrumbs; last as isLast" >
                <div *ngIf="breadcrumb.label!=''" class="flex items-center ml-1 whitespace-nowrap">
                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                    <a *ngIf="breadcrumb.url" class="ml-1 whitespace-nowrap text-primary-500" [ariaLabel]="breadcrumb.label" [routerLink]="breadcrumb.url">{{breadcrumb.label}}</a>
                    <!-- <span *ngIf="isLast" class="ml-1 text-secondary">{{breadcrumb.label}}</span> -->
                    <span *ngIf="!breadcrumb.url" class="ml-1 text-secondary">{{breadcrumb.label}}</span>
                    
                </div>
                
            </div>
            <!-- <div class="flex items-center ml-1 whitespace-nowrap">
                <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>
                <span class="ml-1 text-secondary">{{activePageTitle}}</span>
            </div> -->
        </div>
    </div>
   
</div>

<!-- <ul>
    <li *ngFor="let breadcrumb of (breadcrumbs$ | async)">
      <a [href]="breadcrumb.url">{{ breadcrumb.label }}</a>
    </li>
  </ul> -->
  